<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left epigraph-content">‘We must be willing to let go of the life we planned so as to have the life that is waiting for us.’</p>
<p class="alignment-block-content alignment-block-content-left epigraph-content"><i>— Joseph Campbell</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?4f50287e